<script setup lang="ts">
import UploadFilesDialog from '#operations/file-uploads/components/UploadFilesDialog.vue'
import UploadQueue from '#operations/file-uploads/components/UploadQueue.vue'
import PageHeader from '#shared/components/PageHeader.vue'

definePage({
  meta: { requiresAuth: true, title: 'File uploads' },
})
</script>

<template>
  <PageHeader
    title="File uploads"
    description="Queue a customer's files for the M2M pipeline. data-ingestion releases them a few at a time, so a large batch never floods categorization."
  >
    <template #actions>
      <UploadFilesDialog />
    </template>
  </PageHeader>

  <UploadQueue />
</template>
